var moduleMap = {
	"./Pages": () => {
		return Promise.all([__webpack_require__.e(74673), __webpack_require__.e(20561), __webpack_require__.e(1043), __webpack_require__.e(43801), __webpack_require__.e(36029), __webpack_require__.e(20963), __webpack_require__.e(5989), __webpack_require__.e(30735), __webpack_require__.e(82064), __webpack_require__.e(30432), __webpack_require__.e(90484), __webpack_require__.e(23867), __webpack_require__.e(95717), __webpack_require__.e(63842), __webpack_require__.e(12337), __webpack_require__.e(54528), __webpack_require__.e(87578), __webpack_require__.e(23382), __webpack_require__.e(13163)]).then(() => (() => ((__webpack_require__(113163)))));
	},
	"./Reducers": () => {
		return Promise.all([__webpack_require__.e(95717), __webpack_require__.e(37971), __webpack_require__.e(8363)]).then(() => (() => ((__webpack_require__(408363)))));
	},
	"./Router": () => {
		return Promise.all([__webpack_require__.e(74673), __webpack_require__.e(20561), __webpack_require__.e(1043), __webpack_require__.e(43801), __webpack_require__.e(36029), __webpack_require__.e(20963), __webpack_require__.e(5989), __webpack_require__.e(30735), __webpack_require__.e(82064), __webpack_require__.e(30432), __webpack_require__.e(90484), __webpack_require__.e(23867), __webpack_require__.e(95717), __webpack_require__.e(63842), __webpack_require__.e(12337), __webpack_require__.e(54528), __webpack_require__.e(87578), __webpack_require__.e(23382), __webpack_require__.e(34287)]).then(() => (() => ((__webpack_require__(634287)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});